import { useEffect } from 'react';
import { useAppDispatch } from '../store';
import { getSettings } from '../store/settings/api';
import { setAssetUrl } from '../store/active/activeSlice';
import { getItem, setItem } from '../utils/localStorage';
import { config } from '../utils/utils';

export const MEDIA_BASE_URL_SETTINGS_ID =
  'b78d6064-0072-4249-bb26-9f8f97ad07f6';

const ASSET_URL_CACHE_KEY = 'asset-url';
const ASSET_URL_HOST_CACHE_KEY = 'asset-url-api-host';

function getApiHost() {
  try {
    return new URL(config.BASE_URL).host;
  } catch {
    return config.BASE_URL;
  }
}

export function useMediaBaseUrl() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const loadMediaBaseUrl = async () => {
      const envAssetUrl = config.ASSET_URL;

      if (envAssetUrl) {
        dispatch(setAssetUrl({ assetUrl: envAssetUrl }));
        return;
      }

      const apiHost = getApiHost();
      const cachedHost = getItem(ASSET_URL_HOST_CACHE_KEY);
      const cached = getItem(ASSET_URL_CACHE_KEY)?.trim();

      if (cached && cachedHost === apiHost) {
        dispatch(setAssetUrl({ assetUrl: cached }));
      }

      try {
        const result = await dispatch(
          getSettings({ id: MEDIA_BASE_URL_SETTINGS_ID })
        ).unwrap();
        const value = String(result?.value || '').trim();
        if (value) {
          setItem(ASSET_URL_CACHE_KEY, value);
          setItem(ASSET_URL_HOST_CACHE_KEY, apiHost);
          dispatch(setAssetUrl({ assetUrl: value }));
        } else if (!cached || cachedHost !== apiHost) {
          dispatch(setAssetUrl({ assetUrl: '' }));
        }
      } catch (error) {
        console.error('Failed to load media_base_url setting:', error);
        if (cached && cachedHost === apiHost) {
          dispatch(setAssetUrl({ assetUrl: cached }));
        }
      }
    };

    loadMediaBaseUrl();
  }, [dispatch]);
}
